import { useState, useCallback } from 'react'
import { FileItem } from '../../../services/api'

interface UseSelectionReturn {
  selectedFiles: FileItem[]
  isSelected: (fileId: string) => boolean
  toggleSelection: (file: FileItem) => void
  selectAll: (files: FileItem[]) => void
  clearSelection: () => void
  setSelectedByIds: (ids: string[], allFiles: FileItem[]) => void
  hasSelection: boolean
  selectionCount: number
}

export function useSelection(): UseSelectionReturn {
  const [selectedFiles, setSelectedFiles] = useState<FileItem[]>([])

  const isSelected = useCallback(
    (fileId: string) => selectedFiles.some(f => f.fileId === fileId),
    [selectedFiles]
  )

  const toggleSelection = useCallback((file: FileItem) => {
    setSelectedFiles(prev => {
      const exists = prev.some(f => f.fileId === file.fileId)
      if (exists) {
        return prev.filter(f => f.fileId !== file.fileId)
      }
      return [...prev, file]
    })
  }, [])

  const selectAll = useCallback((files: FileItem[]) => {
    setSelectedFiles([...files])
  }, [])

  const clearSelection = useCallback(() => {
    setSelectedFiles([])
  }, [])

  // Para seleção via rubber-band
  const setSelectedByIds = useCallback((ids: string[], allFiles: FileItem[]) => {
    const selected = allFiles.filter(f => ids.includes(f.fileId))
    setSelectedFiles(selected)
  }, [])

  return {
    selectedFiles,
    isSelected,
    toggleSelection,
    selectAll,
    clearSelection,
    setSelectedByIds,
    hasSelection: selectedFiles.length > 0,
    selectionCount: selectedFiles.length
  }
}

export default useSelection
